import { TaskFilter, TaskStatus, Task } from '@/app/core/Models/Task';
import { createReducer, on } from '@ngrx/store';
import {
  GetAllTasksAction,
  GetAllTasksFailAction,
  GetAllTasksSuccessAction,
  GetTasksAction,
  GetTasksFailAction,
  GetTasksSuccessAction,
  SetActiveTasksStatusAction,
  GetMyOpenTasksForHomeAction,
  GetMyOpenTasksForHomeSuccessAction,
  GetMyOpenTasksForHomeFailAction,
  InvalidateTasksCacheAction,
  InvalidateTasksCacheSuccessAction
} from './action';

export interface TasksState {
  activeTasksStatus: TaskStatus[];
  filter: TaskFilter;
  fetching: boolean;
  
  // Home page specific state
  myOpenTasksForHome: Task[];
  myOpenTasksForHomeFetching: boolean;
  myOpenTasksForHomeLastUpdated: Date | null;
  myOpenTasksForHomeError: string | null;
  
  // Cache management
  cacheInvalidated: boolean;
}

export const initTasksState: TasksState = {
  activeTasksStatus: [],
  filter: TaskFilter.Mine,
  fetching: false,
  
  // Home page initial state
  myOpenTasksForHome: [],
  myOpenTasksForHomeFetching: false,
  myOpenTasksForHomeLastUpdated: null,
  myOpenTasksForHomeError: null,
  
  // Cache management
  cacheInvalidated: false
};

export const tasksReducer = createReducer(
  initTasksState,
  on(SetActiveTasksStatusAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      activeTasksStatus: payload
    };
  }),
  on(GetAllTasksAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: true,
      filter: payload.filter ?? TaskFilter.All
    };
  }),
  on(GetAllTasksSuccessAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: false,
    };
  }),
  on(GetAllTasksFailAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: false,
    };
  }),
  on(GetTasksAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: true,
    };
  }),
  on(GetTasksSuccessAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: false,
    };
  }),
  on(GetTasksFailAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      fetching: false,
    };
  }),
  
  // Home page reducers
  on(GetMyOpenTasksForHomeAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      myOpenTasksForHomeFetching: true,
      myOpenTasksForHomeError: null
    };
  }),
  on(GetMyOpenTasksForHomeSuccessAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      myOpenTasksForHome: payload,
      myOpenTasksForHomeFetching: false,
      myOpenTasksForHomeLastUpdated: new Date(),
      myOpenTasksForHomeError: null
    };
  }),
  on(GetMyOpenTasksForHomeFailAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      myOpenTasksForHomeFetching: false,
      myOpenTasksForHomeError: payload
    };
  }),
  
  // Cache management reducers
  on(InvalidateTasksCacheAction, (state: TasksState, { payload }) => {
    return {
      ...state,
      cacheInvalidated: false // Will be set to true on success
    };
  }),
  on(InvalidateTasksCacheSuccessAction, (state: TasksState) => {
    return {
      ...state,
      cacheInvalidated: true
    };
  })
);
